import * as React from 'react';
import { connect } from 'react-redux';
import matchSorter from 'match-sorter';
import { Row, Col } from 'reactstrap';
import { IReduxState } from '../../../../reduxTypes';
import { IAuthState } from '../../../Auth/store/types';
import { bindActionCreators } from 'redux';
import { loginActions } from '../../../Auth/store/actions';
import { IAgency } from '../../../../share/types/agency';
import AgencyCard from './components/AgencyCard';
import './agencyView.css';
import { AgencyCardLoader } from 'src/share/components/ChartLoader/AgencyCardLoader';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { SearchBox } from 'src/share/components/Filter/SearchBox';
import { SortBox } from 'src/share/components/Filter/SortBox';
import { RoutesModules } from 'src/modules/Routing/types';

const sortOptions = {
    name: 'Name',
    country: 'Country',
    email: 'Email',
    code: 'Code'
}

export interface IAgencyViewState {
    fullData: IAgency[];
    data: any[];
    loading: boolean;
};

export interface IAgencyViewProps {
    auth: IAuthState;
    history: any;
    getAgencies: () => void;
};

export class AgenciesView extends React.Component<IAgencyViewProps, IAgencyViewState> {
    constructor(props: IAgencyViewProps) {
        super(props);
        this.state = {
            fullData: [],
            data: [],
            loading: false
        };
    }
    public componentDidMount() {
        this.fetchData();
    }

    public static getDerivedStateFromProps(props: IAgencyViewProps, state: IAgencyViewProps) {
        return {
            fullData: props.auth.agencies,
        }
    }

    public async fetchData() {
        this.setState({ loading: true });
        await this.props.getAgencies()
        this.setState({ loading: false, data: this.props.auth.agencies || [] });
    }

    public onSearchChange(search) {
        const filteredData = matchSorter(this.state.fullData, search, { keys: ["code", "contact", "country", "email", "name"] });
        this.setState({ data: filteredData });
    }

    public onSortChange(sort) {
        const filteredData = this.state.fullData.sort((a, b) => a[sort] < b[sort] ? -1 : a[sort] > b[sort] ? 1 : 0);
        this.setState({ data: filteredData });
    }

    public render() {
        return (
            <>
                <div className="filters-box">
                    <SearchBox onSearch={(key) => this.onSearchChange(key)} />
                    <SortBox onSort={(key) => this.onSortChange(key)} options={sortOptions} />
                </div>
                <div className="agencies-view">
                    {
                        !this.state.loading &&
                        <Row>
                            {
                                (this.state.data && this.state.data.length > 0) ? this.state.data.map((agency) => (
                                    <AgencyCard key={agency.code} agency={agency} history={this.props.history} />
                                )) : <h4 className="no-results">No data found</h4>
                            }
                        </Row>
                    }
                    {
                        this.state.loading &&
                        <Row>
                            {Array.apply(null, { length: 12 }).map((data, index) => <Col key={index} xl="4" lg="6" md="12" sm="12" xs="12" className="card-column"><AgencyCardLoader /></Col>)}
                        </Row>
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IReduxState) => ({
    auth: state.auth
});

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({
        getAgencies: loginActions.getAgencies,
    }, dispatch);
};

export default SidebarContainer(RoutesModules.AGENCIES)(connect(mapStateToProps, mapDispatchToProps)(AgenciesView));